// extracted by mini-css-extract-plugin
module.exports = {"lightButton":"GoogleMapPlaces_lightButton__CSbcT","darkButton":"GoogleMapPlaces_darkButton__kirw_"};